import StaticDataService from "@/services/staticData.service";
import { useStore } from "vuex";
interface StaticDataState {
  nodeClientUrl: string;
  userTypes: any[];
  orgTypes: any[];
  groupTypes: any[];
  relationshipTypes: any[];
  userPermissions: any[];
  formResponsesCount: number;
  displayAvailableFundsWarning: boolean;
}

const state = {
  nodeClientUrl: "",
  userTypes: [],
  orgTypes: [],
  groupTypes: [],
  relationshipTypes: [],
  userPermissions: [],
  formResponsesCount: 0,
  displayAvailableFundsWarning: false,
};

const getters = {
  getGroupTypes: (state: StaticDataState) => state.groupTypes,
  getUserTypes: (state: StaticDataState) => state.userTypes,
};

const actions = {
  loadStaticData(context: any) {
    context.commit("LOAD_STATIC_DATA");
    return StaticDataService.loadStaticData().then((response: any) => {
      context.commit("LOAD_STATIC_DATA_SUCCESS", response.data.data);
    });
  },
};

const mutations = {
  LOAD_STATIC_DATA(state: StaticDataState) {
    state.nodeClientUrl = "";
    state.userTypes = [];
    state.orgTypes = [];
    state.groupTypes = [];
    state.relationshipTypes = [];
    state.userPermissions = [];
    (state.formResponsesCount = 0), (state.displayAvailableFundsWarning = false);
  },
  LOAD_STATIC_DATA_SUCCESS(state: StaticDataState, data: any) {
    state.nodeClientUrl = data.nodeClientUrl;
    state.userTypes = data.userTypes;
    state.orgTypes = data.orgTypes;
    state.groupTypes = data.groupTypes;
    state.relationshipTypes = data.relationshipTypes;
    state.userPermissions = data.userPermissions;
    state.formResponsesCount = data.formResponsesCount;
    state.displayAvailableFundsWarning = data.displayAvailableFundsWarning;
  },
};

export const staticData = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
